import { ApiNames, ApiProxy, ApiRequest } from '@lib/api/apiProxy';

export class CastingCompaniesQueryApi {
  private static apiProxy = ApiProxy.getInstance();
  private static apiName = ApiNames.CastCompanies;

  public static getAllCompanies(): Promise<any> {
    const endpoint = `/companies/all`;
    return this.apiProxy.execute(new ApiRequest(this.apiName, endpoint));
  }

  public static getCompany(companyId: number): Promise<any> {
    const endpoint = `/companies/${companyId}`;
    return this.apiProxy.execute(new ApiRequest(this.apiName, endpoint));
  }

  public static getProjectsByUsers(userIds: number[]): Promise<ProjectByUser> {
    const endpoint = `/users/projects?user_ids=[${userIds}]`;
    return this.apiProxy.execute<ProjectByUser>(
      new ApiRequest(this.apiName, endpoint)
    );
  }

  public static getCompaniesByUsers(
    userIds: number[]
  ): Promise<CompaniesByUser> {
    const endpoint = `/users/companies?user_ids=[${userIds}]`;
    return this.apiProxy.execute<CompaniesByUser>(
      new ApiRequest(this.apiName, endpoint)
    );
  }

  public static getUsersByCompanies(
    companyIds: number[]
  ): Promise<EmployeeByCompany> {
    const endpoint = `/companies/users?company_ids=[${companyIds}]`;
    return this.apiProxy.execute<EmployeeByCompany>(
      new ApiRequest(this.apiName, endpoint)
    );
  }

  public static checkCompanySubdomainIsAvailable(
    subdomain: string,
  ): Promise<CompanySubdomainAvailability> {
    const endpoint = `/subdomain/availability?subdomain=${subdomain}`;
    return this.apiProxy.execute(new ApiRequest(this.apiName, endpoint));
  }

  public static checkOldCompanySubdomains(): Promise<OldSubdomains> {
    const endpoint = `/oldsubdomains?app_type=casting`;
    return this.apiProxy.execute(new ApiRequest(this.apiName, endpoint));
  }
}
